/**
 * Repräsentation des Ortes aus dem Backend (Kursnet-Daten)
 */
export interface Ort {
  name: string;
  postleitzahl?: string;
  breitengrad: number;
  laengengrad: number;
}

export function encodeOrt(ort: Ort): string {
  const parts = ort.postleitzahl
    ? [encodeOrtName(ort.name), ort.postleitzahl, ort.laengengrad, ort.breitengrad]
    : [encodeOrtName(ort.name), ort.laengengrad, ort.breitengrad];
  return parts.join('_');
}

// Da ',' der Value-Separator ist, muss dieser escaped werden.
function encodeOrtName(name: string): string {
  return name.replaceAll(',', ';');
}

export function decodeOrt(ort: string): Ort {
  const parts: string[] = ort.split('_');
  const ortMitPlz = parts.length == 4;

  if (ortMitPlz) {
    return {
      name: decodeOrtName(parts[0]),
      postleitzahl: parts[1],
      breitengrad: parseFloat(parts[3]),
      laengengrad: parseFloat(parts[2])
    };
  } else {
    return {
      name: decodeOrtName(parts[0]),
      breitengrad: parseFloat(parts[2]),
      laengengrad: parseFloat(parts[1])
    };
  }
}

export function decodeOrtName(name: string): string {
  return name.replaceAll(';', ',');
}
